// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GLQWzVaH8JeGi1rCBt4U {
  border: 1px solid #aaa;
}
`, "",{"version":3,"sources":["webpack://./src/components/SvgImageEditor/styles.module.less"],"names":[],"mappings":"AAAA;EACE,sBAAA;AACF","sourcesContent":[".container {\n  border: 1px solid #aaa;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `GLQWzVaH8JeGi1rCBt4U`
};
export default ___CSS_LOADER_EXPORT___;
